/**
 * app/utils/platform.ts
 * ----------------------
 * What: Small helper to map React Native `Platform.OS` into an app-specific
 * union type used in analytics/metadata.
 * Why: Keeps platform detection consistent and type-safe.
 */
import { Platform } from 'react-native';

export type PlatformType = 'web' | 'mobile-web' | 'ios' | 'android';

export function getPlatform(): PlatformType {
  if (Platform.OS === 'web') {
    return 'web';
  } else if (Platform.OS === 'ios') {
    return 'ios';
  } else {
    return 'android';
  }
} 